import routes from 'src/config/api.routes';
import axios from './axiosService';

class GuarantorService {
  // Personal Information
  GetGuarantor = async guarantorId => axios.get(`${routes.relatedParties}/${guarantorId}/personal-info-by-id`);

  CreateGuarantor = async (entityId, guarantorId, body) => axios.post(
      `${routes.relatedParties}/${entityId}/create-personal-info/${guarantorId}`,
      body
    );

  DeleteBusinessOfGuarantor = async businessId => axios.delete(
      `${routes.relatedParties}/delete-related-party-business/${businessId}`
    );

  // Liabilities
  GetLiabilitiesOfGuarantor = async guarantorId => axios.get(
      `${routes.company}/guarantor/${guarantorId}/financial-info/liabilities`
    );

  UpdateGeneralLiabilitiesOfGuarantor = async body => axios.post(
      `${routes.company}/guarantor/financial-info/general-liabilities`,
      body
    );

  DeleteOutstandingLoansOfGuarantor = async loanId => axios.delete(
      `${routes.company}/guarantor/financial-info/liabilities/outstanding-loans/${loanId}`
    );

  UpdateOutstandingLoansOfGuarantor = async loans => axios.post(
      `${routes.company}/guarantor/financial-info/liabilities/outstanding-loans`,
      loans
    );

  DeleteOtherLiabilitiesOfGuarantor = async otherId => axios.delete(
      `${routes.company}/guarantor/financial-info/liabilities/other-liabilities/${otherId}`
    );

  UpdateOtherLiabilitiesOfGuarantor = async body => axios.post(
      `${routes.company}/guarantor/financial-info/liabilities/other-liabilities`,
      body
    );

  DeleteUnpaidTaxesLiabilitiesOfGuarantor = async unpaidTaxId => axios.delete(
      `${routes.company}/guarantor/financial-info/liabilities/unpaid-taxes/${unpaidTaxId}`
    );

  UpdateUnpaidTaxesLiabilitiesOfGuarantor = async unpaidTaxes => axios.post(
      `${routes.company}/guarantor/financial-info/liabilities/unpaid-taxes`,
      unpaidTaxes
    );

  DeleteCreditCardBalanceOfGuarantor = async cardId => axios.delete(
      `${routes.company}/guarantor/financial-info/liabilities/credit-cards/${cardId}`
    );

  UpdateCreditCardBalancesOfGuarantor = async cardBalances => axios.post(
      `${routes.company}/guarantor/financial-info/liabilities/credit-cards`,
      cardBalances
    );

  // Assets
  GetAssetsOfGuarantor = async guarantorId => axios.get(
      `${routes.company}/guarantor/${guarantorId}/financial-info/assets`
    );

  UpdateAssetsGuarantor = async (guarantorId, assets) => axios.post(
      `${routes.relatedParties}/${guarantorId}/general-assets`,
      assets
    );

  UpdateLifeInsuranceOfGuarantor = async lifeInsurance => axios.put(
      `${routes.company}/guarantor/financial-info/assets/life-insurance`,
      lifeInsurance
    );

  UpdateAutomobilesOfGuarantor = async automobiles => axios.put(
      `${routes.company}/guarantor/financial-info/assets/automobiles`,
      automobiles
    );

  DeleteAutomobile = async (guarantorId, automobileId) => axios.delete(
      `${routes.company}/guarantor/${guarantorId}/financial-info/assets/automobiles/${automobileId}`
    );

  UpdateOtherAssetsOfGuarantor = async assets => axios.put(
      `${routes.company}/guarantor/financial-info/assets/others`,
      assets
    );

  DeleteOtherAsset = async (guarantorId, assetId) => axios.delete(
      `${routes.company}/guarantor/${guarantorId}/financial-info/assets/others/${assetId}`
    );

  UpdateStocksBondsOfGuarantor = async (guarantorId, stocksBonds) => axios.post(
      `${routes.relatedParties}/${guarantorId}/stocks-and-bonds`,
      stocksBonds
    );

  DeleteStockBond = async (guarantorId, stockBondId) => axios.delete(
      `${routes.company}/guarantor/${guarantorId}/financial-info/assets/stock-bond/${stockBondId}`
    );

  UpdatePropertiesOfGuarantor = async (guarantorId, properties) => axios.post(
      `${routes.relatedParties}/${guarantorId}/real-state`,
      properties
    );

  DeleteProperty = async (guarantorId, propertyId) => axios.delete(
      `${routes.company}/guarantor/${guarantorId}/financial-info/assets/property/${propertyId}`
    );
}
const guarantorService = new GuarantorService();
export default guarantorService;
